
import React from 'react'
import styles from './styles/btn-with-arrow.module.scss'

interface BtnWithArrowProps {
  onClick?: () => any
  isDisabled?: boolean
  direction?: string
}

const BtnWithArrow: React.FC<BtnWithArrowProps> = ({ onClick, direction = 'right', isDisabled = false, children }) => {

  return (

    <button type='button' className={`${styles.btnNext} ${isDisabled ? styles.disabled : ''}`} onClick={onClick}>

      {direction === 'left' &&
        <svg style={{marginRight:'4px'}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
          <path stroke={isDisabled?"#737680":"#003A70"} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" d="M15.556 9.945H5M8.694 13.64L5 9.944 8.694 6.25" />
        </svg>
      }

      {children}

      {direction === 'right' &&
        <svg style={{marginLeft:'4px'}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
          <path stroke={isDisabled?"#737680":"#003A70"} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" d="M4.444 10.055H15M11.306 6.36L15 10.056l-3.694 3.695" />
        </svg>
      }
    </button>
  )
}

export default BtnWithArrow